import React from 'react';
import * as yup from 'yup';

import { useFormik } from 'formik';

import { useDispatch } from 'react-redux';
import { listProducts } from '../../modules/productModule/products';
import { ProductListBox } from '../../components/productmng/ProductListBox';

// 추가/엑셀 업로드 버튼은 ProductListContainer의 breadcrumb action으로 이동(2026-10-22, chancemng 설계 적용).
const ProductSearchContainer = ({ downloadExl }) => {
  const dispatch = useDispatch();

  const initialValues = {
    searchKeyword: 'productNm',
    searchWords: '',
  };

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      let searchData = {
        [values.searchKeyword]: values.searchWords,
      };

      setTimeout(() => {
        // alert(JSON.stringify(values, null, 2));
        dispatch(listProducts(searchData));
        // formik.resetForm();
        setSubmitting(false);
      }, 1000);
    },
  });

  const handleDownloadExl = () => {
    let searchData = {
      [formik.values.searchKeyword]: formik.values.searchWords,
    };
    downloadExl(searchData);
  };

  // 검색 카드 "초기화" - 이 화면은 별도 reset 액션이 없고 formik 초기값이 상수라
  // resetForm()으로 바로 되돌리고 초기 조회(인자 없음)를 다시 호출한다(2026-10-22).
  const handleReset = () => {
    formik.resetForm();
    dispatch(listProducts());
  };

  return <ProductListBox formik={formik} onReset={handleReset} />;
};

export default ProductSearchContainer;
